import { render, staticRenderFns } from "./SalesUploader.vue?vue&type=template&id=0252a54e&scoped=true"
import script from "./SalesUploader.vue?vue&type=script&lang=js"
export * from "./SalesUploader.vue?vue&type=script&lang=js"
import style0 from "./SalesUploader.vue?vue&type=style&index=0&id=0252a54e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0252a54e",
  null
  
)

export default component.exports